import { connect } from "react-redux";
import { DesignChapterMob as Component } from "./DesignChapterMob";
import { getNextMenuValue } from "../NotebookExpDesignTab/NotebookExpDesignTab.selector";
import {
  getTitle,
  getViewType,
  getSlideTree,
  getDescription,
} from "./DesignChapterMob.Selector";
import {
  setDesignTab,
  viewThreeHint,
  viewFourHint,
} from "@learningblocks/exp-redux";

function mapStateToProps(state) {
  return {
    title: getTitle(state),
    viewType: getViewType(state),
    slideTree: getSlideTree(state),
    description: getDescription(state),
    nextMenuValue: getNextMenuValue(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSetTab: (params) => {
      dispatch(setDesignTab(params));
    },
    viewThreeHint: () => {
      dispatch(viewThreeHint());
    },
    viewFourHint: () => {
      dispatch(viewFourHint());
    },
  };
}

export const DesignChapterMob = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
